import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloPisoPvcRigido from '../components/sections/PisoDePvcRigido/TituloPisoPvcRigido'; 
import IntroPisoDePvcRigido from '../components/sections/PisoDePvcRigido/IntroPisoDePvcRigido'; 
import CatalogoPisoDePvcRigido from '../components/sections/PisoDePvcRigido/CatalogoPisoDePvcRigido'; 
import FormularioContactoPvcRigido from '../components/sections/PisoDePvcRigido/FormularioContactoPvcRigido'; 
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisoDePvcRigido = () => {
  return (
    <div>
      <SeoMetadata
        title="Piso de PVC Rígido | Decototal"
        description="Descubre pisos de PVC rígido para renovar tus espacios. Consulta los modelos disponibles, conoce sus características y pide una cotización."
        keywords="piso de PVC rígido, piso vinílico rígido, piso PVC, revestimiento para pisos"
        path="/piso-de-pvc-rigido"
        image="/assets/img/productos/piso-de-pvc-rigido/piso-pvc-titulo.jpg"
      />
      <Header />
        <TituloPisoPvcRigido />  
        <IntroPisoDePvcRigido /> 
        <CatalogoPisoDePvcRigido /> 
        <FormularioContactoPvcRigido />
      <Footer />
    </div>
  );
};

export default PisoDePvcRigido;